import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { UserRole } from "@services/accountFeature.service";
import { AuthorizationService } from "@services/authorization.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";

export class Config {

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(FleetNavigationModule.Geofences, {
            url: "/geofences/:panel/:geofence",
            views: {
                "content@app": {
                    template: require("./geofences_moved.html"),
                    //controller: "geofencesController",
                    //controllerAs: "$ctrl"
                }
            },
            params: {
                position: { squash: true, value: null, dynamic: true },
                geofence: { squash: true, value: null, dynamic: true },
                visits: { squash: true, value: null, dynamic: true },
                panel: { squash: true, value: null, dynamic: true },
            },
            data: { translation: 'Common.Geofences' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.ManageGeofences])]
            }
        });
    }
}

angular
    .module("app.components.geofences", [
        "ui.router",
        "ngMaterial"
    ])
    .config(["$stateProvider", Config])
    //.controller("geofencesController", GeofencesController)
